import { render, staticRenderFns } from "./UserRelatedProjects.vue?vue&type=template&id=5bdb7913"
import script from "./UserRelatedProjects.vue?vue&type=script&lang=ts"
export * from "./UserRelatedProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports